import { useContext } from "react";
import { usePlosTranslations } from "../../contexts/PlosTranslationsContext";
import { WebViewContext } from "../../contexts/WebViewContext";
import Link from "../links/Link";
import styles from "./gameTabs.module.css";

export type GameId = "classic" | "challenge" | "draft";

interface GameTabsProps {
  activeGame: GameId;
  onTabPress?: (id: GameId) => void;
}

const GameTabs = ({ activeGame, onTabPress }: GameTabsProps) => {
  const { gameTabs } = usePlosTranslations();
  const { isWebView } = useContext(WebViewContext);

  if (isWebView) {
    return null;
  }

  const gameUrls: Record<GameId, string> = {
    classic: import.meta.env.VITE_CLASSIC_URL ?? "#",
    challenge: import.meta.env.VITE_CHALLENGE_URL ?? "#",
    draft: import.meta.env.VITE_DRAFT_URL ?? "#",
  };

  const gameLinks: { id: GameId; name: string }[] = [
    { id: "classic", name: gameTabs.classic },
    { id: "challenge", name: gameTabs.challenge },
    { id: "draft", name: gameTabs.draft },
  ];

  return (
    <nav aria-label={gameTabs.navLabel} className={styles.wrapper}>
      {gameLinks.map(({ id, name }) => {
        const active = id === activeGame;
        return (
          <Link
            key={id}
            href={gameUrls[id]}
            className={active ? styles.activeLink : styles.link}
            aria-current={active ? "page" : undefined}
            isDisabled={active}
            onPress={() => onTabPress?.(id)}
          >
            {name}
          </Link>
        );
      })}
    </nav>
  );
};

export default GameTabs;
